// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"6e74797cb372f3dfffba","303":"df69692e1034a291ef1c","495":"c5c4b575234dfaefb304"}[chunkId] + ".js";
};